import Axios from '@/services/Axios';
import { ErrorResponse } from '@/common/models/ErrorResponse';
import { TokenUtils } from '@/utils/TokenUtils';
import { PendingInvoiceSaleList } from '../common/models/PendingInvoiceSaleList';
import { SaleNoInvoiceSingleItem } from '../common/models/SaleNoInvoiceSingleItem';

export default {
/* eslint-disable no-console */

  async getPendingInvoiceList(
    limit = -1, offset = -1,
    filterInvoice = 1,
  ) {
    const params = {
      limit,
      offset,
      filterInvoice,
    };
    const headers = {
      Authorization: `Bearer ${TokenUtils.getToken()}`,
    };
    try {
      // eslint-disable-next-line no-shadow
      const { data: response } = await Axios.get(
        '/invoice/pending-invoice-sale/list',
        { headers, params },
      );
      return response.map((element) => (
        new PendingInvoiceSaleList(
          element.client,
          element.createdDt,
          element.foil,
          element.id,
          element.total,
        )
      ));
    } catch (e) {
      console.error(e);
      throw (new ErrorResponse(e.response.data));
    }
  },

  async getPendingInvoiceTableCount(
    startDate = null,
    endDate = null,
    clientId = null,
    paymentMethod = null,
    storeId = null,
  ) {
    const params = {};

    if (!!startDate) {
      params.startDate = startDate;
    }

    if (!!endDate) {
      params.endDate = endDate;
    }

    if (!!clientId) {
      params.clientId = clientId;
    }

    if (!!paymentMethod) {
      params.paymentMethod = paymentMethod;
    }

    if (!!storeId) {
      params.storeId = storeId;
    }

    const headers = {
      Authorization: `Bearer ${TokenUtils.getToken()}`,
    };

    try {
      const { data: response } = await Axios.get(
        '/invoices/pending-invoice-sale/table-count',
        { headers, params },
      );
      return response.count;
    } catch (e) {
      console.error(e.response);
      throw (new ErrorResponse(e.response.data));
    }
  },

  async getPendingInvoiceTable(
    limit, offset,
    startDate = null,
    endDate = null,
    clientId = null,
    paymentMethod = null,
    storeId = null,
  ) {
    const params = {
      limit,
      offset,
    };

    if (!!startDate) {
      params.startDate = startDate;
    }
    if (!!endDate) {
      params.endDate = endDate;
    }
    if (!!clientId) {
      params.clientId = clientId;
    }

    if (!!paymentMethod) {
      params.paymentMethod = paymentMethod;
    }

    if (!!storeId) {
      params.storeId = storeId;
    }

    const headers = {
      Authorization: `Bearer ${TokenUtils.getToken()}`,
    };

    try {
      const { data: response } = await Axios.get(
        '/invoices/pending-invoice-sale/table',
        { headers, params },
      );
      const items = response.items.map((element) => (
        new SaleNoInvoiceSingleItem(
          element.foil,
          element.createdDt,
          element.total,
          element.paymentMethod,
          element.employee,
          element.store,
          element.creditCardPayments,
          element.debitCardPayments,
        )
      ));
      const { total } = response;
      const totalAmericanExpress = response.totalAmericanExpressPayments;
      return { items, total, totalAmericanExpress };
    } catch (e) {
      console.error(e.response);
      throw (new ErrorResponse(e.response.data));
    }
  },

  async getFacturaSale(id, replaceDocumentDt = 0) {
    const params = {
      id,
      replaceDocumentDt,
    };
    const headers = {
      Authorization: `Bearer ${TokenUtils.getToken()}`,
    };
    try {
      const { data: response } = await Axios.get('/facturala/sale', { headers, params });
      return response;
    } catch (e) {
      console.error(e);
      throw (new ErrorResponse(e));
    }
  },

  async getInvoiceEmmiter() {
    const headers = {
      Authorization: `Bearer ${TokenUtils.getToken()}`,
    };
    try {
      const { data: response } = await Axios.get('/invoice/emitter', { headers });
      return response;
    } catch (e) {
      console.error(e);
      throw (new ErrorResponse(e.response.data));
    }
  },

  async getClientInvoiceList(
    limit = -1, offset = -1,
  ) {
    const params = {
      limit,
      offset,
    };
    const headers = {
      Authorization: `Bearer ${TokenUtils.getToken()}`,
    };
    try {
      const { data: response } = await Axios.get('/invoice/client/list', { headers, params });
      return response;
    } catch (e) {
      console.error(e);
      throw (new ErrorResponse(e.response.data));
    }
  },

  async getInvoiceMisc() {
    const headers = {
      Authorization: `Bearer ${TokenUtils.getToken()}`,
    };
    try {
      const { data: response } = await Axios.get('/invoice/misc', { headers });
      return response;
    } catch (e) {
      console.error(e);
      throw (new ErrorResponse(e.response.data));
    }
  },

  async postFacturalaSaleInvoice(factura) {
    const json = JSON.stringify(factura);
    let resp = null;
    try {
      // resp = await Axios.post('/facturala/sale/invoice', factura);
      resp = await Axios.post('/facturala/sale/invoice', json, {
        headers: {
          'Content-Type': 'application/json',
        },
      });
    } catch (e) {
      console.error(e);

      let errorPayload = { message: e };
      if (e.response && e.response.data) {
        errorPayload = e.response.data;
      }
      resp = new ErrorResponse(errorPayload);
    }
    return resp;
  },

  async postGlobalSaleInvoice(sales) {
    const json = JSON.stringify(sales);
    let resp = null;
    try {
      resp = await Axios.post('/facturala/global-sales', json, {
        headers: {
          'Content-Type': 'application/json',
        },
      });
    } catch (e) {
      console.error(e);
      resp = new ErrorResponse(e);
    }
    return resp;
  },

  async getInvoicesTableCount(
    searchQuery = null,
    startDate = null,
    endDate = null,
  ) {
    const params = {};

    if (!!searchQuery) {
      params.searchQuery = searchQuery;
    }

    if (!!startDate) {
      params.startDate = startDate;
    }

    if (!!endDate) {
      params.endDate = endDate;
    }

    const headers = {
      Authorization: `Bearer ${TokenUtils.getToken()}`,
    };

    try {
      const { data: response } = await Axios.get('/invoices/table-count', { headers, params });
      return response.count;
    } catch (e) {
      console.error(e.response);
      throw (new ErrorResponse(e.response.data));
    }
  },

  async getInvoicesTable(
    limit, offset,
    searchQuery = null,
    startDate = null,
    endDate = null,
  ) {
    const params = {
      limit,
      offset,
    };

    if (!!searchQuery) {
      params.searchQuery = searchQuery;
    }

    if (!!startDate) {
      params.startDate = startDate;
    }

    if (!!endDate) {
      params.endDate = endDate;
    }

    const headers = {
      Authorization: `Bearer ${TokenUtils.getToken()}`,
    };

    try {
      const { data: response } = await Axios.get('/invoices/table', { headers, params });
      return response;
    } catch (e) {
      console.error(e.response);
      throw (new ErrorResponse(e.response.data));
    }
  },

  async getFiscalRegimeById(id) {
    let response = null;
    const data = await Axios.get(`/fiscal-regime/${id}`);
    response = data.data;
    return response;
  },

  async getInvoiceClientsAutocomplete(query = '', limit = 20) {
    const params = { query, limit };
    const headers = {
      Authorization: `Bearer ${TokenUtils.getToken()}`,
    };

    try {
      const { data } = await Axios.get('/invoices/table/filtered-by-client', { headers, params });
      return (data || []).map((x) => ({
        rfc: x.rfc,
        name: x.name,
        zipCode: x.zipCode ?? x.zip_code ?? '',
        fiscalRegimeId: x.fiscalRegimeId ?? x.fiscal_regime_id ?? null,
        label: `${x.name} - ${x.rfc}`,
      }));
    } catch (e) {
      console.error(e.response);
      throw (new ErrorResponse(e.response.data || e));
    }
  },
};
